var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcHomeFill(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 20,
    viewBox: "0 0 24 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.4592 0.660308C12.3261 0.556423 12.1621 0.5 11.9932 0.5C11.8243 0.5 11.6603 0.556423 11.5272 0.660308L0.75 9.06451L1.68203 10.2433L3 9.21563V18.5C3.00081 18.8975 3.15911 19.2786 3.44024 19.5597C3.72137 19.8408 4.10242 19.9991 4.5 20H19.5C19.8976 19.9992 20.2787 19.841 20.5599 19.5598C20.841 19.2787 20.9993 18.8976 21 18.5V9.22246L22.318 10.25L23.25 9.07111L12.4592 0.660308ZM13.5 18.5H10.5V12.5H13.5V18.5Z",
    fill: "#D1281F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcHomeFill);
export default __webpack_public_path__ + "static/media/Ic_HomeFill.04b71dc15b2c930baa287780b6def1df.svg";
export { ForwardRef as ReactComponent };